import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Image, Loader } from 'semantic-ui-react';
import * as mime from 'react-native-mime-types';
import { useTranslation } from 'react-i18next';

export default function UploadButton({ currentFile, isUploading, editable, onDelete, type, icon, label, labelDelete, acceptedFileExtensions, onFileSelected, disabled }) {
    const showUploadLabel = isUploading || (currentFile && !editable);
    const showDeleteLabel = currentFile && onDelete;
    const acceptedMimeTypes = acceptedFileExtensions.map(value => mime.lookup(value));
    const onChange = React.useCallback(({ target }) => onFileSelected(target.files[0]), [onFileSelected]);

    return (
        <div>
            {currentFile && type === 'image' ? <ImagePreview src={currentFile.url} /> : null}
            {isUploading ? <Loader active inline="centered" /> : null}
            {showUploadLabel ? <LabelUpload icon={icon} label={label} /> : null}

            <input id="uploadButton" hidden disabled={disabled} type={type} accept={acceptedMimeTypes.join(', ')} onChange={onChange} />
            {showDeleteLabel ? <LabelDelete label={labelDelete} onDelete={onDelete} /> : null}
        </div>
    );
}

UploadButton.propTypes = {
    acceptedFileExtensions: PropTypes.arrayOf(PropTypes.string).isRequired,
    icon: PropTypes.string,
    type: PropTypes.oneOf(['file', 'image']),
    isUploading: PropTypes.bool,
    editable: PropTypes.bool,
    currentFile: PropTypes.any,
    disabled: PropTypes.bool,
    onFileSelected: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
    label: PropTypes.node,
    labelDelete: PropTypes.node
};

UploadButton.defaultProps = {
    labelDelete: null,
    icon: '',
    disabled: false,
    isUploading: false,
    editable: true,
    type: 'file',
    onDelete: null
};

/**
 * render the react button
 * @return {ReactElement} - The Upload button
 */
function ImagePreview({ src }) {
    return (
        <div style={{ width: '100%', height: '100px', textAlign: 'center' }}>
            <Image src={src} style={{ height: 'inherit', margin: '0 auto', paddingBottom: '15px' }} />
        </div>
    );
}

ImagePreview.propTypes = {
    src: PropTypes.string.isRequired
};

function LabelUpload({ icon, label }) {
    return (
        <label htmlFor="uploadButton" className="ui button upload-file">
            {icon ? <Icon name={icon} /> : null}
            {label}
        </label>
    );
}

LabelUpload.propTypes = {
    icon: PropTypes.string,
    label: PropTypes.node.isRequired
};
LabelUpload.defaultProps = {
    icon: ''
};

function LabelDelete({ onDelete, label }) {
    const { t } = useTranslation();
    return (
        <label htmlFor="deleteButton" className="ui button upload-file" onClick={onDelete}>
            <Icon name="trash" />
            {label || t(['ticket.common.action.delete', 'Unselect this file'])}
        </label>
    );
}

LabelDelete.propTypes = {
    onDelete: PropTypes.func.isRequired,
    label: PropTypes.node.isRequired
};
